import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Address } from '../../models/address'
import * as _ from 'lodash'
import { PhoneNumberInputMask } from '../../../common/input-masks/phone-number.input-mask'
import { LengthTextFieldValidator } from '../../../validations/length-text-field-validator'
import { NumericTextFieldValidator } from '../../../validations/numeric-text-field-validator'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { UserPhone } from '../../models/user-phone'
import { State } from '../../models/state'

@Component({
    templateUrl: './business-and-residential-address.component.html',
    selector: 'BusinessAndResidentialAddress'
})
export class BusinessAndResidentialAddressComponent implements OnInit {
    @Input() businessAddress: Address
    @Input() residentialAddress: Address
    @Input() businessPhone: UserPhone
    @Input() cellPhone: UserPhone

    @Input() silverMailOptIn: boolean
    @Input() isAdminUpdate: boolean
    

    @Output() onBusinessAddressChange: EventEmitter<Address> = new EventEmitter<Address>()
    @Output() onResidentialAddressChange: EventEmitter<Address> = new EventEmitter<Address>()
    @Output() onsilverMailOptInChange: EventEmitter<boolean> = new EventEmitter<boolean>()
    

    phoneNumberInputMask = new PhoneNumberInputMask()
    lengthValidator = new LengthTextFieldValidator(10)
    numericValidator = new NumericTextFieldValidator()
    notBlankValidator = new NotBlankGenericFieldValidator()

    sameAsBusinessAddress = false

    ngOnInit(): void {
        // if (!_.isEqual(this.businessAddress, {}) &&  _.isEqual(this.businessAddress, this.residentialAddress)) {
        //  this.sameAsBusinessAddress = true
        // }
    }

    clickOnSameAsBusinessAddress() {
        this.sameAsBusinessAddress = !this.sameAsBusinessAddress
        if (this.sameAsBusinessAddress) {
            this.onResidentialAddressChange.emit(_.clone(this.businessAddress))
        } else {
            this.clearResidentialAddress()
            this.onResidentialAddressChange.emit(this.residentialAddress)
        }
    }

    clearResidentialAddress() {
        this.residentialAddress.city = ''
        this.residentialAddress.line1 = ''
        this.residentialAddress.line2 = ''
        this.residentialAddress.zip = ''
        this.residentialAddress.zip4 = ''
        this.residentialAddress.state = {} as State
    }

    updateBusinessAddress(newBusinessAddress: Address) {
        this.onBusinessAddressChange.emit(_.clone(newBusinessAddress))
        if (this.sameAsBusinessAddress) {
            this.onResidentialAddressChange.emit(_.clone(newBusinessAddress))
        }
    }
}
